import React from 'react'
import styled, { css } from 'styled-components'

import { fixIe, getColor, getFontSize, objectFit } from '../../utils/cssUtils'
import mq from '../../utils/mediaQuery'
import ImgContainer from '../AspectBox'
import Picture from '../Picture'

const Card = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: inset 0 0 0 1px rgba(181, 181, 181, 0.2);
  background-color: #fff;
  ${({ listView }) =>
    listView &&
    css`
      ${mq.desktopTablet} {
        flex-wrap: nowrap;
      }
    `}
`
const CardImgWrapper = styled.div`
  width: 100%;
  ${({ listView }) =>
    listView &&
    css`
      ${mq.desktopTablet} {
        flex-shrink: 0;
        width: 277px;
      }
    `}
`
const CardImg = styled(ImgContainer)`
  img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    ${objectFit('cover')}
  }
`
const CardContent = styled.div`
  width: 100%;
  padding: 24px;
  ${({ listView }) =>
    listView &&
    css`
      ${mq.desktopTablet} {
        padding: 16px 24px;
      }
    `}
`
export const Title = styled.span`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  font-size: ${getFontSize('title')};
  line-height: 1.5;
  height: ${18 * 1.5 * 2}px;
  max-height: 50px;
  font-weight: bold;
  margin-bottom: 8px;
  color: ${getColor('black')};
  ${({ listView }) =>
    listView &&
    css`
      ${mq.desktopTablet} {
        margin-bottom: 4px;
      }
    `}
  ${fixIe(
    css`
      overflow: hidden;
      display: flex;
    `
  )}
`
export const Description = styled.p`
  font-size: ${getFontSize('body2')};
  line-height: 1.5;
  height: ${16 * 1.5 * 3}px;
  max-height: 70px;
  margin-bottom: 0;
  color: ${getColor('grey')};
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
`
const ArticleCard = React.memo(
  ({ title, description, mainImage, listView, imageSizes, className }) => {
    return (
      <Card className={className} listView={listView}>
        <CardImgWrapper listView={listView}>
          <CardImg>
            <Picture image={mainImage} sizes={imageSizes} />
          </CardImg>
        </CardImgWrapper>
        <CardContent listView={listView}>
          <Title listView={listView}>{title}</Title>
          <Description>{description}</Description>
        </CardContent>
      </Card>
    )
  }
)

export default ArticleCard
